import stickybits from 'stickybits'

const stickyOpts = {
    stickyBitStickyOffset: 100
}

stickybits('[data-sticky]', stickyOpts);

theme.cart = {

    // The current form for context.
    form: null,

    /*
        Initialise the Cart.
        @link https://cartjs.org/

        @param - debug true|false
    */
    init: function(debug) {

        CartJS.init(cart, {
            debug: debug,
            requestBodyClass: 'ajax--cart'
        });
        
        // Add some listeners to the cart
        this.addListeners(cart);

        // Hide the loader
        this.bootUI()

        // Update cart count
        this.showCartIndicator(cart)

    },

    /*
        Cart Error
        @return Array
    */
    error: function(data) {
        console.error('[Sureify Cart] ----- Error]', data.responseJSON.description)
        this._updateMessaging('error', data.responseJSON.description, data)
        // Reset the button back to initial state.
        let $form = $(theme.cart.form)
        $form.find('[data-cartbutton-spinner]').addClass('hidden invisible')
        $form.find('[data-cartbutton-spinner-text]').removeClass('hidden invisible')
        $form.find('[data-cartbutton-spinner-complete]').addClass('hidden invisible')
    },

    /*
        Cart Success
        @return Array
    */
    success: function (data) {
        console.info('%c[Sureify Cart] ----- Success]', 'color: #75f582;')
        // Store the current form for setTimeouts.
        let $form = $(theme.cart.form)
        // Update any messaging
        this._updateMessaging('success', theme.language.cart_success, data)
        // Update cart indicator
        this.showCartIndicator()
        // Add a small tick
        $form.find('[data-cartbutton-spinner-complete]').removeClass('hidden invisible')
        // Hide the spinner
        $form.find('[data-cartbutton-spinner]').addClass('hidden invisible')
        // Show a view cart button
        clearTimeout(timeout)
        let timeout = setTimeout(function(){
            // Reset the button back to initial state.
            $form.find('[data-cartbutton-spinner-text]').removeClass('hidden invisible')
            $form.find('[data-cartbutton-spinner-complete]').addClass('hidden invisible')
            $form.find('[data-view-basket]').slideDown(200);
            setTimeout(function(){
                // Reset the button back to initial state.
                $form.find('[data-view-basket]').fadeOut(200);
                $form.find('[data-form-mini]').addClass('opacity-0 invisible')
            }, 10000)
        }, 250)
    },

    /*
        Cart Success
        @return Array
    */
    updated: function (data) {
        console.info('%c[Sureify Cart] ----- Success]', 'color: #75f582;')
        this._updateMessaging('success', theme.language.cart_updated, data)
        this.showCartIndicator()
    },

    /*
        @return event - The event
        @global cart - The current cart (window.cart)

        Triggered whenever Cart.js begins to process the request queue.
        Note that if you make multiple Ajax-triggered calls to Cart.js (say, two calls to addItem in a row), 
        this event will still only fire once.
    */
    started: function(event, cart) {},

    /*
        @return event - The event
        @global cart - The current cart (window.cart)

        Triggered whenever Cart.js begins to process the request queue.
        Note that if you make multiple Ajax-triggered calls to Cart.js (say, two calls to addItem in a row), 
        this event will still only fire once.
    */
    completed: function(event, cart) {

        if (cart.item_count == 0) {
            $('[data-cart-promotion]').addClass('hidden')
            $('[data-cart-message]').addClass('hidden')
            $('[data-cart-empty]').removeClass('hidden')
        }

        // Update the count
        this.showCartIndicator()

    },
    /*
        Add an item to the cart

        @return void
        @param jQuery event
        @link - https://cartjs.org/pages/guide#core-api-adding-items
    */
    addItem: function(event) {

        // Prevent default
        event.preventDefault()

        // Form (context)
        theme.cart.form = $(event.currentTarget).closest("form");

        // The element spinners
        $(theme.cart.form).find('[data-cartbutton-spinner-text]').addClass('hidden invisible')
        $(theme.cart.form).find('[data-cartbutton-spinner]').removeClass('hidden invisible')
        $(theme.cart.form).find('[data-form-mini]').removeClass('opacity-0 invisible')

        // The Variant ID
        let id = $(theme.cart.form).find('[name="id"]').val()

        // The quantity
        let qty = $(theme.cart.form).find('[name="quantity"]').val()

		// The Properties
		let properties = this._getItemProperties($(theme.cart.form))

        // Add the item
        CartJS.addItem(id, qty, properties, {
            "success": this.success.bind(this),
            "error": this.error.bind(this)
        });

        
        // Show the sidebar
        // this._showSidebar()

    },

    /*
        Add items to the cart

        @return event - The event
        @global cart - The current cart (window.cart)

        Multiple items method not in use by default
    */
    addItems: function(event) {},

    /*
        Add some vent listeners for the Cart
        @link https://cartjs.org/pages/reference#events
    */
    addListeners() {
        
        // The cart request completed. 
        $(document).on('cart.requestComplete', this.completed.bind(this));

        // The cart request started. 
        // $(document).on('cart.requestStarted', this.started.bind(this));
        
        // Add an item to the cart.
        $(document).on('click', 'button[name="add"]', this.addItem.bind(this))

        // Update quantity
        $(document).on('click', '[data-cart-quantity]', this.updateQuantity.bind(this))

        // Open the sidebar
        // $('[data-open-cart-sidebar]').on('click', function(e) {
        //     e.preventDefault()
        //     $('body').addClass('modal--open')
        //     $('[data-cart-sidebar]').addClass('is--open');
        // })

        // Close the sidebar
        // $('[data-close-cart-sidebar]').on('click', function(e) {
        //     e.preventDefault()
        //     theme.cart._hideSidebar()
        // })   
        // Close the sidebar clicking anywhere but the sidebar and sidebar close
        // $(document).on('click', function (event) {
        //     if (!$(event.target).closest('[data-cart-sidebar]').length && 
        //         !$(event.target).closest('[data-open-cart-sidebar]').length) {
        //         theme.cart._hideSidebar()
        //     }
        // });
        
    },

    /*
        Update the item quantty
    */
    updateQuantity(event) {

        // Prevent default.
        event.preventDefault()

        // The jQuery target.
        let $target = $(event.currentTarget)

        // The current product form,
        let $properties = $target.parents("[data-cart-item]");

        // The type of quantity update.
        let type = $target.data('cart-quantity')

        // The variant id
        let variantId = $target.data('id')
        
        // The index or "line number"
        let index = $target.data('index');

        // The variant properties.
        let properties = this._getItemProperties($properties)
        
        // Callbacks.
        let options = {
            "success": this.updated.bind(this),
            "error": this.error.bind(this)
        }
        
        // Remove the product by variant id
        if (type === 'remove') {
            CartJS.updateItemById(variantId, 0);
        }

        // Reduce the product by variant id
        if (type === 'minus') {

            // Get the cart line item
            let qty = CartJS.cart.items[index].quantity
            qty = qty - 1
            if (qty >= 1) {
                CartJS.updateItemById(variantId, qty, properties, options);
            }

        }

        // Add the product by variant id
        if (type === 'plus') {
            
            /*
                We call addItem rather than updateItemById due to the
                error callback not firing with updateItemById, e.g.
                "You cannot add another X to cart..."
            */
            CartJS.addItem(variantId, 1, properties, options);
        }

    },

    /*
        Show the basket when it's ready
    */
    bootUI() {

        $('[data-cart-view]').removeClass('hidden invisible')
        $('[data-cart-loading]').addClass('hidden invisible')

        // Sticky basket 
        let $basketContainer = $('.basket-container');
        if ($basketContainer.length > 0) {
            let lastScrollTop = 0
            let stickyBasket = $('[data-sticky]')
            let stickyBasketPosition = ($(stickyBasket).position().top - $(stickyBasket).height());
            // $(window).on('scroll', _.debounce(() => {
            //     let top = window.pageYOffset || document.documentElement.scrollTop;
            //     // Downward!
            //     if (top > lastScrollTop) {
            //         // Have we reached the target div?
            //         if (top > stickyBasketPosition) {
            //             $('[data-fixed-checkout-button]').fadeOut(300)
            //         } else {
            //             $('[data-fixed-checkout-button]').fadeIn(300)
            //         }
            //     // Upward!
            //     } else {
            //         // User potentially doesn't want to checkout to hide the button
            //         $('[data-fixed-checkout-button]').fadeOut(300)
            //     }
            //     // For negative scrolling effects on mobile
            //     lastScrollTop = top <= 0 ? 0 : top;
            // }, 100))       
        }
   },
    /*
        Update the cart count icon
    */
    showCartIndicator() {
        
        if (CartJS.cart.item_count > 0) {
            $('[data-cart-count]').removeClass('hidden')
        } else {
            $('[data-cart-count]').addClass('hidden')
        }

    },
    /*
        Get the item properties
    */
   _getItemProperties($target) {

        let array = []
        $target.find('input[name^="properties"]').each(function() {
            let propertyName = $(this).attr('name')
            let matches = propertyName.match(/\[(.*?)\]/);
            if (matches) {
                propertyName = matches[1]
            }
            array[propertyName] = $(this).val()
        })

        return array;

   },

    /*
        Update the cart count icon
    */
    _updateMessaging(type, message, data) {

        console.info('%c[Sureify Cart] ----- Update Messaging]', 'color: #75f582;')

        let messageContainer = $('[data-cart-message]')
        if (type == 'error') {
            messageContainer.removeClass('cart--success')
            messageContainer.addClass('cart--error')
        } else {
            message = message.replace('{product_name}', data.product_title)
            messageContainer.removeClass('cart--error')
            messageContainer.addClass('cart--success')
        }

        messageContainer.removeClass('hidden')
        messageContainer.html(message)

    },

        /*
        Open the cart sidebar
    */
    // _showSidebar() {
        
    //     // Open the sidevar
    //     $('[data-cart-sidebar]').addClass('is--open');
    //     $('body').addClass('modal--open')

    //     // Figure out the heights incase of overflow.
    //     let header = $('[data-cart-sidebar-header]').outerHeight()
    //     let footer = $('[data-cart-sidebar-footer]').outerHeight()
    //     let body = $('[data-cart-sidebar]').outerHeight()

    //     // Set the height for the inner portions.
    //     let calc = (body - header - footer)
    //     $('[data-cart-lines]').height(calc)

    // },

    /*
        Close the cart sidebar
    */
    // _hideSidebar() {
    //     $('[data-cart-sidebar]').removeClass('is--open');
    //     $('body').removeClass('modal--open')
    //     $('[data-cart-message]').addClass('hidden');
    // },

}

$(function() {
    let debug = false
    theme.cart.init(debug)
});